import Vue from 'vue';
import Vuetify from 'vuetify/lib';

//import 'material-design-icons-iconfont/dist/material-design-icons.css'; // (md)
import '@mdi/font/css/materialdesignicons.css' // (mdi)

import light from './vuetify/lightTheme';

import i18n from '@/localization/i18n.js';
import it from 'vuetify/es5/locale/it';
import en from 'vuetify/es5/locale/en';

Vue.use(Vuetify);

export default new Vuetify({
	theme: {
		//dark: true
		options: { customProperties: true },
		themes: { light },
	},
	icons: {
		iconfont: 'mdi'
	},
	lang: {
		locales: { it, en },
		current: i18n.locale,
		 
		/**
		 * Per sostiuire messaggi vuetify (definiti nei files locales di vuetify)
		 * aggiungere nei file custom della lingua (che hanno già magari messaggi custom)
		 * anche quelli di default di vuetify
		 * 
		 * $vuetify 
		 * 
		 * e scommentare la seguente riga
		 */
		//t: (key, ...params) => i18n.t(key, params),
	}
});
